import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  InputGroup,
  InputRightElement,
  Divider,
} from "@chakra-ui/core";
import SearBox from "../elements/SearchBox";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/high-res.css";
import { useCustomers } from "../../hooks/customer";

/** Conllecting/Rendering info about the customer (buyers) */

const CustomerDetailsForm = ({ handleChange, successMessage, setCustomerInfo, setError }) => {
  const [selectedCustomer, setSelectedCustomer] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [searchString, setSearchString, matches] = useCustomers();

  useEffect(()=>{
    setCustomerInfo(selectedCustomer)
  },[selectedCustomer, setCustomerInfo]

  );
  /** If we already reached the end of the 
  cycle within the happy path we do not render the form anymore */
  if (successMessage) {
    return <></>;
  }
  const handleSearchedItem = async (search) => {
    setSelectedCustomer(search);
    Object.keys(search).map((key) =>
      handleChange({ target: { name: `${key}`, value: search[key] } })
    );
  };

  const handleFormUpdate = ({ target: { name, value } }) => {
    console.log("updating this part");
    setSelectedCustomer((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <>
      <Box>
        <SearBox
          entity="existing customers"
          searchString={searchString}
          setSearchString={setSearchString}
          matches={matches}
          handleSearchedItem={handleSearchedItem}
          widget={true}
        />
      </Box>
      <Divider my="3" />
      <FormLabel textTransform="uppercase">Customer details</FormLabel>
      <Stack spacing={2} p="8px">
        {selectedCustomer.email || selectedCustomer.phone ? (
          <>
            <FormControl isRequired>
              <Stack spacing={2}>
                <Input
                  name="firstName"
                  focusBorderColor="info.500"
                  id="firstName"
                  type="text"
                  placeholder="First name"
                  aria-describedby="Customer first name"
                  value={selectedCustomer.firstName}
                  onChange={handleFormUpdate}
                />
                <Input
                  name="lastName"
                  focusBorderColor="success.500"
                  id="lastName"
                  type="text"
                  placeholder="Last name"
                  aria-describedby="Customer last name"
                  value={selectedCustomer.lastName}
                  onChange={handleFormUpdate}
                />
                <InputGroup>
                  <InputRightElement
                    children={<Box as={MdEmail} color="primary.400" />}
                  />
                  <Input
                    name="email"
                    id="email"
                    focusBorderColor="success.500"
                    type="email"
                    placeholder="Email address"
                    aria-describedby="User email address field"
                    value={selectedCustomer.email}
                    onChange={handleFormUpdate}
                  />
                </InputGroup>
              </Stack>
            </FormControl>
            <InputGroup mt="8px">
              <InputRightElement
                children={<Box as={FaMobileAlt} color="primary.400" />}
              />
              <PhoneInput
                onlyCountries={["fr", "es"]}
                localization={{ fr: "France", es: "España" }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                country={"fr"}
                onChange={(phone) => {
                  handleChange({ target: { name: "phone", value: phone } });
                }}
                value={selectedCustomer.phone}
                disableSearchIcon={true}
                regions={"europe"}
                inputStyle={{
                  color: "#56566C",
                  border: "none",
                  marginLeft: "12px",
                  fontSize: "16px",
                }}
                containerStyle={{
                  paddingLeft: "0px",
                  border: "1px solid #E5E5F2",
                  borderRadius: "5px",
                }}
                buttonStyle={{
                  backgroundColor: "#fafafa",
                  border: "none",
                  padding: "4px",
                }}
                dropdownStyle={{
                  border: "1px solid #D6D6EE",
                  background: "#fafafa",
                  boxShadow: "none",
                  borderRadius: "0px",
                  textAlign: "left",
                  borderBottomRightRadius: "5px",
                  borderBottomLeftRadius: "5px",
                }}
                searchStyle={{
                  border: "1px solid #9898B5",
                  width: "98%",
                  padding: "8px",
                  margin: "0px",
                }}
              />
            </InputGroup>
          </>
        ) : (
          <>
            <FormControl isRequired>
              <Stack spacing={2}>
                <Input
                  name="firstName"
                  focusBorderColor="success.500"
                  id="firstName"
                  type="text"
                  placeholder="First name"
                  aria-describedby="Customer first name"
                  onChange={handleChange}
                />
                <Input
                  name="lastName"
                  focusBorderColor="success.500"
                  id="lastName"
                  type="text"
                  placeholder="Last name"
                  aria-describedby="Customer last name"
                  onChange={handleChange}
                />
                {/* <InputGroup>
              <InputLeftElement
                children={<Box as={FaMobileAlt} color="primary.400" />}
              />
              <Input
                name="phone"
                id="phone"
                onChange={handleChange}
                focusBorderColor="success.500"
                type="phone"
                placeholder="Phone number"
              />
            </InputGroup> */}
                <InputGroup>
                  <InputRightElement
                    children={<Box as={MdEmail} color="primary.400" />}
                  />
                  <Input
                    name="email"
                    id="email"
                    focusBorderColor="success.500"
                    type="email"
                    placeholder="Email address"
                    aria-describedby="User email address field"
                    onChange={handleChange}
                  />
                </InputGroup>
              </Stack>
            </FormControl>
            <InputGroup mt="8px">
              <InputRightElement
                children={<Box as={FaMobileAlt} color="primary.400" />}
              />
              <PhoneInput
                onlyCountries={["fr", "es"]}
                localization={{ fr: "France", es: "España" }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                country={"fr"}
                onChange={(phone) => {
                  handleChange({ target: { name: "phone", value: phone } });
                }}
                disableSearchIcon={true}
                regions={"europe"}
                inputStyle={{
                  color: "#56566C",
                  border: "none",
                  marginLeft: "12px",
                  fontSize: "16px",
                }}
                containerStyle={{
                  paddingLeft: "0px",
                  border: "1px solid #E5E5F2",
                  borderRadius: "5px",
                }}
                buttonStyle={{
                  backgroundColor: "#fafafa",
                  border: "none",
                  padding: "4px",
                }}
                dropdownStyle={{
                  border: "1px solid #D6D6EE",
                  background: "#fafafa",
                  boxShadow: "none",
                  borderRadius: "0px",
                  textAlign: "left",
                  borderBottomRightRadius: "5px",
                  borderBottomLeftRadius: "5px",
                }}
                searchStyle={{
                  border: "1px solid #9898B5",
                  width: "98%",
                  padding: "8px",
                  margin: "0px",
                }}
              />
            </InputGroup>
          </>
        )}
      </Stack>
      <Divider my={6} />
    </>
  );
};

export default CustomerDetailsForm;
